import React, { useState } from "react";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

/**
 * Deutscher Datums-Picker (TT.MM.JJJJ) — Drop-in-Ersatz für <input type="date">.
 * value/onChange sind kompatibel: value = ISO "YYYY-MM-DD", onChange erhält { target: { value } }.
 */
export const GermanDateInput = ({ value, onChange, className = "", min, max, placeholder = "TT.MM.JJJJ", ...rest }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const valid = selected && !isNaN(selected.getTime());
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button"
          className={`input-tech font-mono text-left flex items-center gap-2 whitespace-nowrap ${className}`}
          {...rest}>
          <CalendarIcon size={12} strokeWidth={1.5} className="text-slate-400 shrink-0" />
          {valid ? format(selected, "dd.MM.yyyy", { locale: de }) : <span className="text-slate-400">{placeholder}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border border-slate-200" align="start">
        <Calendar
          mode="single"
          locale={de}
          weekStartsOn={1}
          captionLayout="dropdown"
          fromYear={1950}
          toYear={new Date().getFullYear() + 5}
          selected={valid ? selected : undefined}
          defaultMonth={valid ? selected : undefined}
          disabled={(d) => {
            if (min && d < new Date(`${min}T00:00:00`)) return true;
            if (max && d > new Date(`${max}T23:59:59`)) return true;
            return false;
          }}
          onSelect={(d) => {
            if (d) onChange({ target: { value: format(d, "yyyy-MM-dd") } });
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default GermanDateInput;
